<div id="policy-container">
  <div id="content-container">
    <h1 class="card-header" *ngIf="ls.policyHeader">{{ls.policyHeader | uppercase}}</h1>
    <div id="content" *ngIf="ls.servicesArticle" [innerHTML]="ls.policyArticle">
    </div>
  </div>
</div>
